import EuFormContainer from 'components/eu/EuFormContainer';

export default function BeMigrationFormPage() {
  const contentfulId = '5edgFZ7rg4cu3XUcTD5AZ4'; // Belgium Form Page
  const country = 'BELGIUM';
  return <EuFormContainer contentfulId={contentfulId} country={country} />;
}
